/* PP · Band – seitlich rollende Reihe mit Pfeilen links/rechts (Reiter, Knöpfe, Filterzeile, Regale): Pfeile nur, wenn es in die Richtung weitergeht,
   gewählten Eintrag ins Bild holen, runde Pfeile mittig auf die Produktbilder (Regale).
   Wo benutzt (lädt jeder dieser Bausteine selbst): sections/pp-kategorie, pp-modellleiste, pp-regale, pp-landing, snippets/pp-filterzeile, pp-flaschenknoepfe
   Abschaltbar: mit dem jeweiligen Baustein (ohne Skript rollt die Reihe trotzdem – nur ohne Pfeile)
   Liest: [data-pp-kat-band] mit [data-pp-kat-reihe] und .pp-kat__pfeil--links / --rechts darin; Produktbild .pp-regal__bild / .pp-land__pbild
   Stellt bereit: PP.baender(nachmessen) – für pp-filter.js (aufgeklappte Streifen am Handy neu messen); an jedem Band b.__ppPfeile() (pp-filter.js farbPunkte)
   Fehlt eine Stelle: dieses Band bleibt ohne Pfeile (kein Fehler). Braucht: pp-basis.js (vorher geladen); Aussehen in pp-global.css + im Baustein
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-07 (C4 Schritt 3: aus assets/pp-global.js Abschnitt 9, katBaender) */
(function () {
  var PP = window.PP;
  if (!PP || !PP.erstesMal || !PP.erstesMal('band')) return; // ohne pp-basis.js nichts tun; nur einmal einrichten (Skript steht in mehreren Bausteinen)

  function katBaender(nachmessen) { // nachmessen: auch schon eingerichtete Reihen neu messen (z. B. nach dem Aufklappen am Handy)
    var bs = document.querySelectorAll('[data-pp-kat-band]');
    for (var i = 0; i < bs.length; i++) (function (b) {
      if (b.__pp) { if (nachmessen && b.__ppMessen) b.__ppMessen(); return; }
      b.__pp = true;
      var f = b.querySelector('[data-pp-kat-reihe]'), l = b.querySelector('.pp-kat__pfeil--links'), r = b.querySelector('.pp-kat__pfeil--rechts');
      if (!f || !l || !r) return;
      function pfeile() { var max = f.scrollWidth - f.clientWidth; l.hidden = f.scrollLeft <= 2; r.hidden = max <= 2 || f.scrollLeft >= max - 2; }
      b.__ppPfeile = pfeile; // 01.10.2026: farbPunkte (pp-filter.js) misst danach neu
      // 26.09.2026 (Nutzer: Scroll-Pfeile „sehen fast schon kaputt aus“): runde Pfeile (.pp-pfeil-rund) mittig auf die Produktbilder setzen
      function mitte() { var ib = f.querySelector('.pp-regal__bild, .pp-land__pbild'); if (!ib) return; var m = ib.getBoundingClientRect(), bb = b.getBoundingClientRect();
        if (m.height > 0) b.style.setProperty('--pp-pfeil-mitte', Math.round(m.top - bb.top + m.height / 2) + 'px'); }
      window.addEventListener('resize', mitte);
      l.addEventListener('click', function () { f.scrollBy({ left: -f.clientWidth * 0.6, behavior: 'smooth' }); });
      r.addEventListener('click', function () { f.scrollBy({ left: f.clientWidth * 0.6, behavior: 'smooth' }); });
      f.addEventListener('scroll', pfeile, { passive: true });
      window.addEventListener('resize', pfeile);
      b.__ppMessen = function () { // gewählten Knopf/Wert in den sichtbaren Bereich holen, dann Pfeile setzen
        var a = f.querySelector(':scope > .pp-aktiv'); // 01.10.2026: nur direkte Einträge (nicht gewählte Werte in einem Aufklapper der Filterzeile)
        if (a && a.offsetLeft + a.offsetWidth > f.clientWidth) f.scrollLeft = a.offsetLeft - 40;
        pfeile(); mitte();
      };
      b.__ppMessen();
    })(bs[i]);
  }

  PP.baender = katBaender;
  PP.beimStart(110, function () { katBaender(); });
  PP.nachFilter(110, function () { katBaender(); }); // neu eingesetzte Abschnitte nach dem Filtern ohne Neuladen
})();
